import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { NgModule, ErrorHandler } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import * as Raven from 'raven-js';
import {
  CalendarModule,
  DataTableModule,
  ListboxModule,
  MultiSelectModule,
  StepsModule,
  MenuModule,
  GrowlModule,
  MessagesModule,
  AutoCompleteModule,
  DropdownModule,
  EditorModule,
  InputTextModule,
  ChipsModule,
  DialogModule,
  TooltipModule,
  ToggleButtonModule,
  InputSwitchModule,
  FieldsetModule,
  ConfirmDialogModule,
  ConfirmationService,
  ContextMenuModule,
  SplitButtonModule,
  CheckboxModule,
  RadioButtonModule,

} from 'primeng/primeng';


import {
  MatDialogModule,
  MatInputModule,
  MatButtonModule,
} from '@angular/material';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { FileUploadModule } from 'ng2-file-upload/ng2-file-upload';



import { AppRoutingModule } from './app-routing.module';

import { ReleaseBundleModule } from './release-bundle/release-bundle.module';
import { HomeModule } from './home/home.module';

// Components
import { AppComponent } from './app.component';
import { NavBarComponent } from './nav-bar/nav-bar.component';
import { HomeComponent } from './home/home.component';
import { NewReleaseComponent } from './new-release/new-release.component';
import { LoginComponent } from './login/login.component';
import { ExternalLoginComponent } from './external-login/external-login.component';
// import { ChangePasswordComponent } from './change-password/change-password.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { NewReleaseBundleComponent } from './new-release-bundle/new-release-bundle.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { ReleaseBundleComponent } from './release-bundle/release-bundle.component';
import { ReleaseDetailsComponent } from './release-details/release-details.component';
import { ReleaseBundleDetailsComponent } from './release-bundle-details/release-bundle-details.component';

// Services
import { ReleaseService } from './release-component/release.service';
import { HomeService } from './home/home.service';
import { NewReleaseService } from './new-release/new-release.service';
import { MainService } from './main.service';
import { AuthService } from "./auth.service";
import { NewVersionService } from './new-version/new-version.service';


import { AuthGuard } from './auth-guard.service';
import { DeactivateGuardService } from './deactivate-guard.service';
import { RavenErrorHandler } from './raven-error-handler';
import { UserImageComponent } from './user-image/user-image.component';
import { AddToBundleComponent } from './shared/add-to-bundle/add-to-bundle.component';
import { ReleaseEditModelComponent } from './shared/release-edit-model/release-edit-model.component';
import { AddComponentsToBundleComponent } from './shared/add-components-to-bundle/add-components-to-bundle.component';
import { ViewPermissionComponent } from './view-permission/view-permission.component';
import { SelectQAComponent } from './shared/select-qa/select-qa.component';
import { NewVersionComponent } from './new-version/new-version.component';
import { AddNewVersionComponent } from './shared/add-new-version/add-new-version.component';

Raven
  .config('https://b93de511a3ad458aab0c5017ede41497@sentry.io/1259910')
  .install();

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    NewReleaseComponent,
    LoginComponent,
    ExternalLoginComponent,
    PageNotFoundComponent,
    NavBarComponent,
    NewReleaseBundleComponent,
    ChangePasswordComponent,
    UserImageComponent,
    ReleaseBundleComponent,
    ReleaseDetailsComponent,
    ReleaseBundleDetailsComponent,
    AddToBundleComponent,
    ReleaseEditModelComponent,
    AddComponentsToBundleComponent,
    ViewPermissionComponent,
    SelectQAComponent,
    NewVersionComponent,
    AddNewVersionComponent,
  ],
  entryComponents: [
    ReleaseEditModelComponent,
    AddComponentsToBundleComponent,
    SelectQAComponent,
    NewVersionComponent,
    AddNewVersionComponent,
  ],
  imports: [
    BrowserModule,
    HttpModule,
    ReleaseBundleModule, // this contains release bundle child routes
    HomeModule, // home child routes
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    CalendarModule,
    BrowserAnimationsModule,
    DataTableModule,
    ListboxModule,
    MultiSelectModule,
    StepsModule,
    MenuModule,
    GrowlModule,
    MessagesModule,
    AutoCompleteModule,
    DropdownModule,
    EditorModule,
    InputTextModule,
    ChipsModule,
    DialogModule,
    TooltipModule,
    ToggleButtonModule,
    InputSwitchModule,
    FieldsetModule,
    ConfirmDialogModule,
    ContextMenuModule,
    MatDialogModule,
    MatInputModule,
    MatButtonModule,
    SplitButtonModule,
    FileUploadModule,
    CheckboxModule,
    RadioButtonModule,
  ],
  exports: [
    NavBarComponent,
    NewReleaseBundleComponent,
    ChangePasswordComponent,
    UserImageComponent,
  ],
  providers: [ReleaseService,
    HomeService,
    MainService,
    AuthService,
    AuthGuard,
    DeactivateGuardService,
    ConfirmationService,
    NewReleaseService,
    ChangePasswordComponent,
    NewVersionService,
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }